import { defineStore } from 'pinia';

export interface ModalState {
    state: {
        open: boolean;
        locationModal: boolean;
    };
}

const DEFAULT_STATE = {
    open: false,
    locationModal: false,
};

export const useModalStore = defineStore({
    id: 'modal',
    state: (): ModalState => ({
        state: {
            ...DEFAULT_STATE,
        },
    }),
    actions: {
        updateModal(field: keyof ModalState['state'], value: boolean) {
            this.state[field] = value;
        },
    },
});